import { routeRegistry } from "../route_registry.js";
import { HomePage } from "../home_page.js";
import { DocsPage } from "../docs.js";
import { LoginPage } from "../login_page.js";
import { OverviewPage } from "../overview_page.js";
import { ActionsPage } from "../actions.js";
import { SourcesPage, ChannelsPage } from "../integrations.js";
import { AllItemsPage } from "../items.js";
import { AllIntegrationsPage } from "../integrations_list.js";
import { AllPostsPage } from "../posts.js";
import { ItemPage } from "../item.js";
import { IntegrationPage } from "../integration.js";
import { PostPage } from "../post.js";
import { OrgRootRedirect } from "../org_redirect.js";

// Global routes
routeRegistry.register({
  type: "home",
  path: "/",
  label: "Home",
  component: HomePage,
});

routeRegistry.register({
  type: "docs",
  path: "/docs",
  label: "Docs",
  component: DocsPage,
});

routeRegistry.register({
  type: "login",
  path: "/login",
  label: "Login",
  component: LoginPage,
});

// Org routes
routeRegistry.register({
  type: "overview",
  path: "/o/:orgSlug/overview",
  label: "Overview",
  component: OverviewPage,
});

routeRegistry.register({
  type: "actions",
  path: "/o/:orgSlug/actions",
  label: "Actions",
  component: ActionsPage,
});

routeRegistry.register({
  type: "sources",
  path: "/o/:orgSlug/sources",
  label: "Sources",
  component: SourcesPage,
});

routeRegistry.register({
  type: "channels",
  path: "/o/:orgSlug/channels",
  label: "Channels",
  component: ChannelsPage,
});

routeRegistry.register({
  type: "items",
  path: "/o/:orgSlug/i",
  label: "Items",
  component: AllItemsPage,
});

routeRegistry.register({
  type: "integrations",
  path: "/o/:orgSlug/n",
  label: "Integrations",
  component: AllIntegrationsPage,
});

routeRegistry.register({
  type: "posts",
  path: "/o/:orgSlug/p",
  label: "Posts",
  component: AllPostsPage,
});

// Detail routes
routeRegistry.register({
  type: "item-detail",
  path: "/o/:orgSlug/i/:itemSlug",
  label: "Item",
  component: ItemPage,
});

routeRegistry.register({
  type: "integration-detail",
  path: "/o/:orgSlug/n/:integrationSlug",
  label: "Integration",
  component: IntegrationPage,
});

routeRegistry.register({
  type: "post-detail",
  path: "/o/:orgSlug/p/:postSlug",
  label: "Post",
  component: PostPage,
});

// Redirect route
routeRegistry.register({
  type: "org-root",
  path: "/o/:orgSlug",
  label: "Org",
  component: OrgRootRedirect,
});
